import { createSlice } from "@reduxjs/toolkit";

export const editTagSlice = createSlice({
    name:"editTag",
    initialState: {
        showEditTagDoorModal:false,
        showEditTagUserModal:false,
        selectedTag:null,
    },
    reducers:{
        setShowEditTagDoorModal: (state) => {
            state.showEditTagDoorModal = !state.showEditTagDoorModal;
        },
        setShowEditTagUserModal: (state) => {
            state.showEditTagUserModal = !state.showEditTagUserModal;
        },
        setSelectedTag: (state, action)=> {
            state.selectedTag = action.payload;
        },
        resetEditTag: (state)=> {
            state.showEditTagDoorModal = false;
            state.showEditTagUserModal = false;
            state.selectedLabel = null;
        },
    }
});

export const { setShowEditTagDoorModal, setShowEditTagUserModal, setSelectedTag, resetEditTag } = editTagSlice.actions;

export default editTagSlice.reducer;